export const LOGO_COLOR_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <radialGradient id="terminus-mark-icon-gradient-a" cx="44.984%" cy="44.749%" r="79.61%" fx="44.984%" fy="44.749%"
      gradientTransform="matrix(.77654 .59506 -.63007 .7334 .382 -.149)">
        <stop offset="0%" stop-color="#0098CE"/>
        <stop offset="28.89%" stop-color="#0072C6"/>
        <stop offset="57.81%" stop-color="#0065AC"/>
        <stop offset="100%" stop-color="#00538A"/>
      </radialGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24"/>
      <path fill="url(#terminus-mark-icon-gradient-a)" fill-rule="nonzero" d="M12.5094828,12.1879106 L15.8689156,11.0607065
      C16.0108355,11.0099402 16.1612661,11.112335 16.1612661,11.2597834 L16.1612661,20.787989 C16.1612661,20.9050424 16.0638896,21
      15.9438546,21 L12.5844218,21 C12.4643868,21 12.3670104,20.9050424 12.3670104,20.787989 L12.3670104,12.3868797 C12.3670104,12.297958
      12.4238225,12.2185213 12.5094828,12.1879106 Z M5.00011053,14.848341 L5.00011053,20.7878813 C5.00011053,20.9049346
      5.09748699,20.9998922 5.217522,20.9998922 L8.5444591,20.9998922 C8.66449411,20.9998922 8.76187057,20.9049346 8.76187057,20.7878813
      L8.76187057,13.7516396 C8.76187057,13.6079637 8.61829279,13.5058923 8.47803089,13.5497604 L5.15109379,14.6465695 C5.0611228,14.6745933
      5.00011053,14.7561857 5.00011053,14.848341 Z M16.0412311,3.25876793 L16.3248497,4.59658186 L5.13871449,8.37031222
      C5.05504368,8.40200069 5,8.48046737 5,8.56798791 L5,11.4070162 C5,11.5532789 5.14833055,11.6556737 5.28980828,11.6069553
      L17.1097195,7.63199241 L17.36659,8.72524464 C17.4056069,8.89112408 17.6189287,8.94684837 17.7377479,8.82225016 L21.9416259,4.41281028
      C22.0573502,4.2914456 21.9919168,4.09333877 21.8253489,4.06057246 L16.2962226,3.00429011 C16.1418129,2.97400283 16.0066353,3.1088405
      16.0412311,3.25876793 Z"/>
    </g>
  </svg>
`;
